<template>
  <div
    :id="`gtm_benefit_main_list_banner_${event.eventId}`"
    class="gtm_benefit_main_list_banner tw:py-[14px] tw:pl-3 tw:pr-1.5 tw:flex tw:items-center tw:gap-4 tw:rounded-xl tw:bg-white tw:border tw:border-usdg-color-border-medium tw:cursor-pointer"
    @click="emits('click-event-item')"
  >
    <div class="tw:flex tw:flex-1 tw:items-center tw:gap-2.5 tw:min-w-0">
      <div
        class="tw:flex tw:size-[46px] tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:bg-[#f2f7ff]"
      >
        <nuxt-img
          :src="event.iconUrl"
          alt="event-item"
          width="30"
          height="30"
        />
      </div>
      <div class="tw:flex tw:flex-1 tw:flex-col tw:gap-1 tw:min-w-0">
        <span class="tw:typo-text-l tw:font-medium tw:text-usdg-color-text-title">{{
          event.title
        }}</span>
        <span class="tw:typo-text-s tw:text-usdg-color-text-subtle1">{{ event.subTitle }}</span>
      </div>
    </div>
    <IUsdgNormalChevronRightSmallIcon class="tw:size-6! tw:shrink-0 tw:text-usdg-color-gray-600" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  event: EventItem
}>()

const emits = defineEmits(['click-event-item'])
</script>
